import React from 'react';
import { NavLink } from 'react-router-dom';
import { PageWrapper } from './../components';

export default () => {
  return (
    <PageWrapper pageId={'no-match'}>
      <section>
        <h1 className='medium-header hl-primary'>404 Not Found.</h1>
        <h2 className='light-header hl-secondary'>We're sorry this page doesn't exist.</h2>
        <NavLink to={'/'}>Click here to return home.</NavLink>
      </section>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/NoMatch.js